const clientRoleLabels = {
  UNKNOWN: 'Unknown',
  ACCOUNTANT_WITH_ACCESS: 'Accountant with access',
  ACCOUNTANT_WITHOUT_ACCESS: 'Accountant without access',
  BUSINESS_OWNER: 'Business owner',
  BUSINESS_ADMINISTRATOR: 'Business administrator',
  SPECIALIST: 'Specialist',
  ALTERNATE_CONTACT: 'Alternate contact',
};

const mapClientRolesToOptions = clientRoles =>
  clientRoles.map(({ id, name }) => ({
    value: id,
    label: clientRoleLabels[name] || name,
  }));

export default mapClientRolesToOptions;
